import React from 'react';

import { Button as AntdButton, Modal as AntdModal } from 'antd';

import { CommentaireResponseDto } from 'lib_api/lib/api/gen';

import { Commentaire } from '../DisplayCommentaires/Commentaire/Commentaire';

import { useDeleteCommentaire } from './utils';

import './ModalDeleteCommentaire.less';

interface ModalDeleteCommentaireProps {
  dossierId: string;
  commentaire: CommentaireResponseDto;
  visible: boolean;
  onClose: () => void;
}

export const ModalDeleteCommentaire: React.FC<ModalDeleteCommentaireProps> = ({
  dossierId,
  commentaire,
  visible,
  onClose,
}: ModalDeleteCommentaireProps): React.ReactElement => {
  const { submit, inProgress } = useDeleteCommentaire(
    commentaire?.id,
    dossierId,
    onClose,
  );

  return (
    <AntdModal
      className="modalValidity"
      open={visible}
      onCancel={close}
      footer={null}
      closable={false}
      destroyOnClose={true}
      maskClosable={false}
    >
      <h2>{"Suppression d'un commentaire"}</h2>
      <p>
        Souhaitez-vous supprimer ce commentaire ? Cette action sera définitive.
      </p>
      <div className={'commentairePlaceholder'}>
        <Commentaire
          dossierId={dossierId}
          commentaire={commentaire}
          overflowContent={true}
        />
      </div>
      <div className="modalActions">
        <AntdButton onClick={onClose}>Annuler</AntdButton>
        <AntdButton
          type="primary"
          danger
          loading={inProgress}
          disabled={inProgress}
          onClick={() => submit(commentaire)}
        >
          Supprimer
        </AntdButton>
      </div>
    </AntdModal>
  );
};
